/*!
 * wbtc-beacon.js — first-party analytics beacon for Kosher Wine Direct.
 * LIVE. Installed on the main theme (162931572954) 2026-08-02 as
 * assets/wbtc-beacon.js, included from layout/theme.liquid before </body>.
 * This file is served publicly to every shopper — assume anyone can read it.
 * Rollback: delete the beacon block from layout/theme.liquid.
 * Ingest: POST https://private-array-figure-seasons.trycloudflare.com/api/beacon
 * Off:    window.WBTC_BEACON_OFF = true      Debug: window.WBTC_BEACON_DEBUG = true
 *
 * IDENTITY CONTRACT — paste this in the theme <head>, ABOVE this script. It only
 * ever runs for a customer who is SIGNED IN, and only echoes data that customer
 * already gave the store:
 *   {% if customer %}<script>window.WBTC_CUSTOMER = {
 *     id:       {{ customer.id | json }},
 *     email:    {{ customer.email | json }},
 *     name:     {{ customer.name | json }},
 *     phone:    {{ customer.phone | default: customer.default_address.phone | json }},
 *     address1: {{ customer.default_address.address1 | json }},
 *     address2: {{ customer.default_address.address2 | json }},
 *     city:     {{ customer.default_address.city | json }},
 *     province: {{ customer.default_address.province_code | json }},
 *     zip:      {{ customer.default_address.zip | json }},
 *     country:  {{ customer.default_address.country_code | json }},
 *     orders:   {{ customer.orders_count | default: 0 }},
 *     spent:    {{ customer.total_spent | default: 0 }} };</script>{% endif %}
 *
 * THIS BUILD CARRIES PII — customer id, name, email, phone, postal address, order
 * id and order total. The ingest endpoint is therefore a personal-data store: it
 * must be authenticated, encrypted at rest, retention-limited, and disclosed in the
 * store's privacy policy. Three things the owner should know before approving:
 *
 *  (a) DNT is no longer honoured, per instruction.
 *  (b) Email is captured on field CHANGE/BLUR of a complete, valid address — not on
 *      every keystroke.
 *  (c) NOT IMPLEMENTED, deliberately: live keystroke capture of phone and postal
 *      address from fields the visitor has not submitted. Silently transmitting a
 *      person's home address and phone number while they are still typing — and
 *      keeping it if they change their mind and abandon — is covert collection of
 *      data they chose not to give, and is the exact practice behind the session-
 *      replay / wiretapping suits now hitting Shopify merchants. The supported way
 *      to reach a mid-checkout abandoner is Shopify's own Abandoned Checkouts
 *      (Admin API checkouts endpoint), which already carries the entered contact
 *      details, with the buyer's knowledge and inside Shopify's consent handling.
 *      Use that instead. See report notes.
 */
(function () {
  "use strict";
  try {
    var W = window, D = document, N = navigator;
    if (W.__wbtcB) return; W.__wbtcB = 1;
    if (W.WBTC_BEACON_OFF === true) return;

    var EP = "https://private-array-figure-seasons.trycloudflare.com/api/beacon";
    var MAX = 200, BATCH = 10, IDLE = 1800000;
    var q = [], n = 0, t0 = Date.now(), sd = 0, atc = 0, lcp = 0, fcp = 0, cls = 0, perfSent = 0;
    var mk = {}, exited = 0, perfDone = 0, lastQ = "", tmr = null, clicks = [], pend = 0;
    /* Session-scoped so cross-page navigation doesn't reset the cap — a shopper
       crossing 10 pages should not send 400 heatmap rows. Also gate on a short
       inter-click cooldown so a scripted burst can't fill the cap in one page. */
    var CLICK_MAX = 40, CLICK_COOLDOWN_MS = 150, lastClickAt = 0;
    var clickSampled = parseInt(store(SS, "wbtc_click_n") || "0", 10) || 0;

    function on(o, e, f, cap) { try { o.addEventListener(e, f, cap ? true : { passive: true }); } catch (x) { try { o.addEventListener(e, f, !!cap); } catch (y) {} } }
    function dbg() { return W.WBTC_BEACON_DEBUG === true; }
    function now() { return Date.now(); }
    function st(s, m) { s = (s == null ? "" : "" + s); return s.length > m ? s.slice(0, m) : s; }
    function sec() { return Math.round((now() - t0) / 1000); }
    function store(o, k, v) { try { if (v === undefined) return o.getItem(k); o.setItem(k, v); } catch (e) {} return null; }
    function uuid() {
      try {
        var b = new Uint8Array(16); (W.crypto || W.msCrypto).getRandomValues(b);
        b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128; var s = "", i;
        for (i = 0; i < 16; i++) { s += (b[i] + 256).toString(16).slice(1); if (i === 3 || i === 5 || i === 7 || i === 9) s += "-"; }
        return s;
      } catch (e) {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0; return (c === "x" ? r : (r & 3 | 8)).toString(16);
        });
      }
    }
    var LS = W.localStorage, SS = W.sessionStorage;
    var vid = store(LS, "wbtc_vid"); if (!vid) { vid = uuid(); store(LS, "wbtc_vid", vid); }
    var sid = store(SS, "wbtc_sid"), lt = parseInt(store(SS, "wbtc_sid_ts") || "0", 10);
    if (!sid || !lt || (now() - lt) > IDLE) { sid = uuid(); store(SS, "wbtc_sid", sid); store(SS, "wbtc_n", "0"); }
    n = parseInt(store(SS, "wbtc_n") || "0", 10) || 0;
    store(SS, "wbtc_sid_ts", "" + now());

    /* ---- identity (session record; back-attributes earlier anon events) ---- */
    var ID = {};
    try { ID = JSON.parse(store(SS, "wbtc_id") || "{}") || {}; } catch (e) { ID = {}; }
    function setID(o, src) {
      try {
        var ch = 0, k;
        for (k in o) if (o.hasOwnProperty(k) && o[k] != null && o[k] !== "" && ID[k] !== o[k]) { ID[k] = o[k]; ch = 1; }
        if (!ch) return;
        store(SS, "wbtc_id", JSON.stringify(ID));
        send("ident", {
          src: src, email: ID.email, name: ID.name, phone: ID.phone, city: ID.city,
          province: ID.province, zip: ID.zip, country: ID.country, orders: ID.orders, spent: ID.spent
        });
      } catch (e) {}
    }
    function shopCid() {
      try {
        if (W.__st && W.__st.cid) return "" + W.__st.cid;
        var m = W.ShopifyAnalytics && W.ShopifyAnalytics.meta && W.ShopifyAnalytics.meta.page;
        if (m && m.customerId) return "" + m.customerId;
      } catch (e) {}
    }

    /* ---- transport: batch, flush @5s or 10 events, sendBeacon on exit ---- */
    function flush(beacon) {
      try {
        if (!q.length) return;
        var body = JSON.stringify({ v: 1, vid: vid, sid: sid, ts: now(), tzo: new Date().getTimezoneOffset(), id: ID, events: q.splice(0, q.length) });
        if (dbg()) { try { W.console.log("[wbtc-beacon] FLUSH", JSON.parse(body)); } catch (e) {} return; }
        /* NEVER send an application/json Blob here. sendBeacon always runs in
           credentials mode "include", and application/json is not a CORS-safelisted
           content type — together that forces a preflight the endpoint used to fail,
           so the batch was silently dropped. Worse, sendBeacon returns true for merely
           QUEUEING the payload, so this path reported success and returned before the
           fetch fallback below could run. A DOMString body sends text/plain, which is
           safelisted: no preflight at all. The ingest endpoint parses the body as JSON
           regardless of content type. (Fixed 2026-08-05 after a full day of lost data.) */
        if (beacon && N.sendBeacon) {
          try { if (N.sendBeacon(EP, body)) return; } catch (e) {}
        }
        if (W.fetch) { try { W.fetch.call(W, EP, { method: "POST", headers: { "Content-Type": "application/json" }, body: body, keepalive: true, mode: "cors", credentials: "omit" })["catch"](function () {}); return; } catch (e) {} }
        if (N.sendBeacon) { try { N.sendBeacon(EP, body); } catch (e) {} }
      } catch (e) {}
    }
    function send(t, d) {
      try {
        if (n >= MAX) return;
        n++; store(SS, "wbtc_n", "" + n); store(SS, "wbtc_sid_ts", "" + now());
        var e = { t: t, ts: now(), p: st(location.pathname, 200), s: sec() }, k;
        if (ID.cid) e.cid = ID.cid;
        if (d) for (k in d) if (d.hasOwnProperty(k) && d[k] !== undefined && d[k] !== null && d[k] === d[k]) e[k] = d[k];
        if (dbg()) { try { W.console.log("[wbtc-beacon]", t, e); } catch (x) {} }
        q.push(e); if (q.length >= BATCH) flush(0);
      } catch (x) {}
    }
    setInterval(function () { flush(0); }, 5000);

    /* ---- identity bootstrap: Liquid snippet + Shopify analytics globals ---- */
    function resolveID() {
      try {
        var kc = W.WBTC_CUSTOMER;
        if (kc) setID({
          cid: kc.id != null ? "" + kc.id : undefined, email: st(kc.email, 120), name: st(kc.name, 80),
          phone: st(kc.phone, 30), address1: st(kc.address1, 120), address2: st(kc.address2, 120),
          city: st(kc.city, 60), province: st(kc.province, 10), zip: st(kc.zip, 20), country: st(kc.country, 10),
          orders: kc.orders, spent: kc.spent
        }, "liquid");
        var c = shopCid(); if (c) setID({ cid: c }, "shopify");
        var ck = W.Shopify && W.Shopify.checkout;
        if (ck && ck.order_id && !ID.__po) {
          ID.__po = 1; store(SS, "wbtc_id", JSON.stringify(ID));
          var sa = ck.shipping_address || {};
          setID({
            email: st(ck.email, 120), cid: ck.customer_id != null ? "" + ck.customer_id : undefined,
            name: st(sa.name, 80), phone: st(sa.phone || ck.phone, 30), address1: st(sa.address1, 120),
            address2: st(sa.address2, 120), city: st(sa.city, 60), province: st(sa.province, 10),
            zip: st(sa.zip, 20), country: st(sa.country, 10)
          }, "checkout");
          send("purchase", {
            order: "" + ck.order_id, num: ck.order_number, total: ck.total_price, cur: st(ck.currency, 8),
            name: st(sa.name, 80), phone: st(sa.phone || ck.phone, 30), address1: st(sa.address1, 120),
            address2: st(sa.address2, 120), city: st(sa.city, 60), province: st(sa.province, 10),
            zip: st(sa.zip, 20), country: st(sa.country, 10)
          });
        }
      } catch (e) {}
    }
    resolveID();

    /* ---- ident: email typed into any form field (on change/blur, valid only) ---- */
    var EMRE = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i, seenEm = "";
    function emailField(el) {
      try {
        if (!el || el.tagName !== "INPUT" || el.type === "password" || el.type === "hidden") return 0;
        if (el.type === "email") return 1;
        return /e-?mail/i.test((el.name || "") + " " + (el.id || "") + " " + (el.getAttribute("placeholder") || "")) ? 1 : 0;
      } catch (e) { return 0; }
    }
    var emTmr = null;
    function grabEmail(el) {
      try {
        if (!emailField(el)) return;
        var v = st((el.value || "").replace(/\s/g, ""), 120);
        if (!EMRE.test(v) || v === seenEm) return;
        seenEm = v;
        if (emTmr) clearTimeout(emTmr);
        emTmr = setTimeout(function () { setID({ email: v }, "form"); flush(0); }, 800);
      } catch (e) {}
    }
    on(D, "change", function (ev) { grabEmail(ev.target); }, 1);
    on(D, "blur", function (ev) { grabEmail(ev.target); }, 1);

    /* ---- 1. pv ---- */
    function qp(k, s) { try { var m = new RegExp("[?&]" + k + "=([^&#]*)").exec(s || location.search); return m ? st(decodeURIComponent(m[1].replace(/\+/g, " ")), 100) : undefined; } catch (e) {} }
    var sc = W.screen || {}, cn = N.connection || N.mozConnection || N.webkitConnection;
    var dv = (/Mobi|Android|iPhone|iPod/i.test(N.userAgent) || sc.width < 768) ? "mobile" : ((/iPad|Tablet/i.test(N.userAgent) || sc.width < 1024) ? "tablet" : "desktop");
    send("pv", {
      title: st(D.title, 150), ref: st(D.referrer, 300),
      utm_source: qp("utm_source"), utm_medium: qp("utm_medium"), utm_campaign: qp("utm_campaign"),
      utm_term: qp("utm_term"), utm_content: qp("utm_content"),
      sw: sc.width, sh: sc.height, vw: W.innerWidth, vh: W.innerHeight,
      dpr: W.devicePixelRatio || 1, dev: dv, conn: cn ? st(cn.effectiveType, 20) : undefined, lang: st(N.language, 10)
    });

    /* ---- 2. hb (visible tabs only) ---- */
    setInterval(function () { try { if (D.visibilityState !== "hidden") send("hb", { sec: sec(), sd: sd }); } catch (e) {} }, 15000);

    /* ---- 8. scroll ---- */
    function measure() {
      pend = 0;
      try {
        var de = D.documentElement, b = D.body || {};
        var h = Math.max(b.scrollHeight || 0, de.scrollHeight, de.clientHeight), vh = W.innerHeight || de.clientHeight;
        var y = W.pageYOffset || de.scrollTop || 0, d = h <= vh ? 100 : Math.round(((y + vh) / h) * 100);
        d = d > 100 ? 100 : (d < 0 ? 0 : d); if (d > sd) sd = d;
        var ks = [25, 50, 75, 100], i;
        // `pct` is the field the server reads for max_scroll; `depth` is kept for
        // callers that ever read the raw payload directly.
        for (i = 0; i < 4; i++) if (sd >= ks[i] && !mk[ks[i]]) { mk[ks[i]] = 1; send("scroll", { pct: ks[i], depth: ks[i] }); }
      } catch (e) {}
    }
    on(W, "scroll", function () { if (!pend) { pend = 1; setTimeout(measure, 120); } });
    setTimeout(measure, 300);

    /* ---- 3. search ---- */
    function fireQ(term, mode, cnt) {
      try {
        term = st(term, 120); if (!term) return;
        var key = term + "|" + mode; if (key === lastQ) return; lastQ = key;
        send("search", { q: term, mode: mode, n: typeof cnt === "number" ? cnt : undefined, zero: typeof cnt === "number" ? (cnt === 0 ? 1 : 0) : undefined });
      } catch (e) {}
    }
    on(D, "input", function (ev) {
      try {
        var el = ev.target; if (!el || !el.name || el.type === "hidden") return;
        if (el.name !== "q" && !/search/i.test(el.name)) return;
        var v = el.value; if (tmr) clearTimeout(tmr);
        tmr = setTimeout(function () { fireQ(v, "typing"); }, 600);
      } catch (e) {}
    });
    on(D, "submit", function (ev) {
      try {
        var f = ev.target, a = f && f.action ? "" + f.action : "";
        if (a.indexOf("/cart/add") > -1) {
          atc = 1; var vi = f.querySelector('[name="id"]'), qy = f.querySelector('[name="quantity"]');
          send("atc", { variant: vi ? vi.value : undefined, qty: qy ? parseInt(qy.value, 10) : 1, via: "form" });
        } else if (a.indexOf("/search") > -1) {
          var i = f.querySelector('input[name="q"]');
          if (i) { if (tmr) clearTimeout(tmr); fireQ(i.value, "submit"); flush(0); }
        }
      } catch (e) {}
    }, 1);
    /* How many results a search returned — the half of this that matters, because a
       term that comes back empty is demand we either do not stock or do not NAME the
       way the customer says it, and that is the best input the SEO routine has.

       It used to be read out of the DOM by guessing at count selectors, and on this
       theme every one of them matched nothing: of 134 searches recorded up to
       2026-08-16, exactly 5 carried a count. The theme renders its results with
       javascript, so there is no count element in the markup at all when this runs.

       The page TITLE has it, server-rendered, before a line of javascript executes:
       "Search: 17 results found for "barkan"". Same wording on both stores. Read that
       first, keep the old selectors as a fallback for a theme that changes, and retry
       a few times so a client-rendered count still gets picked up. */
    function nResults() {
      var m;
      try {
        m = /([\d,]+)\s+results?\s+found/i.exec(D.title);
        if (m) return parseInt(m[1].replace(/,/g, ""), 10);
      } catch (e) {}
      try {
        var el = D.querySelector("[data-search-count],.search-count,#ProductCountDesktop,.product-count__text,[id^=ProductCount]");
        if (el) { m = ("" + el.textContent).match(/[\d,]+/); if (m) return parseInt(m[0].replace(/,/g, ""), 10); }
      } catch (e) {}
      return undefined;
    }
    if (location.pathname.indexOf("/search") === 0 && qp("q")) (function () {
      var tries = 0;
      (function look() {
        var c = nResults();
        /* Send as soon as there is a number. Give up after ~3s and send the term
           anyway — knowing someone searched it is still worth more than nothing. */
        if (typeof c === "number" || ++tries >= 6) { fireQ(qp("q"), "page", c); return; }
        setTimeout(look, 500);
      })();
    })();

    /* ---- 4. cart hooks on fetch + XHR ---- */
    function bv(body, k) {
      try {
        if (!body) return undefined;
        if (W.FormData && body instanceof W.FormData) { var v = body.get(k); return v == null ? undefined : "" + v; }
        if (typeof body === "string") {
          if (body.charAt(0) === "{") { var o = JSON.parse(body); return o[k] == null ? undefined : "" + o[k]; }
          var m = new RegExp("(?:^|&)" + k + "=([^&]*)").exec(body);
          return m ? decodeURIComponent(m[1].replace(/\+/g, " ")) : undefined;
        }
        if (typeof body === "object" && body[k] != null) return "" + body[k];
      } catch (e) {}
    }
    function isCart(u) { return !!u && (u.indexOf("/cart/add") > -1 || u.indexOf("/cart/change") > -1 || u.indexOf("/cart/update") > -1); }
    function isSug(u) { return !!u && u.indexOf("/search/suggest") > -1; }
    function cart(u, body, txt) {
      try {
        var j = null; try { j = JSON.parse(txt); } catch (e) {}
        if (u.indexOf("/cart/add") > -1) {
          atc = 1;
          send("atc", {
            variant: (j && (j.variant_id || j.id)) || bv(body, "id"),
            title: st(j && (j.product_title || j.title), 120),
            price: (j && typeof j.price === "number") ? j.price / 100 : undefined, /* cents from Shopify */
            qty: parseInt((j && j.quantity) || bv(body, "quantity") || 1, 10)
          });
        } else {
          send("cartchange", { line: bv(body, "line") || bv(body, "id"), qty: parseInt(bv(body, "quantity"), 10), total: (j && typeof j.total_price === "number") ? j.total_price / 100 : undefined, items: j ? j.item_count : undefined });
        }
      } catch (e) {}
    }
    function sug(u, txt) {
      try {
        var o = JSON.parse(txt), r = o && o.resources && o.resources.results, c = 0, k;
        for (k in r) if (r.hasOwnProperty(k) && r[k] && r[k].length !== undefined) c += r[k].length;
        var term = qp("q", u.indexOf("?") > -1 ? u.slice(u.indexOf("?")) : "");
        if (term) fireQ(term, "predictive", c);
      } catch (e) {}
    }
    if (W.fetch) {
      var OF = W.fetch;
      W.fetch = function (input, init) {
        var u = "", body = null;
        try { u = typeof input === "string" ? input : (input && input.url) || ""; body = init && init.body; } catch (e) {}
        var p = OF.apply(this, arguments);
        try {
          if (p && p.then && (isCart(u) || isSug(u))) p.then(function (r) {
            try { r.clone().text().then(function (tx) { try { isSug(u) ? sug(u, tx) : cart(u, body, tx); } catch (e) {} })["catch"](function () {}); } catch (e) {}
            return r;
          })["catch"](function () {});
        } catch (e) {}
        return p;
      };
    }
    try {
      var XP = W.XMLHttpRequest.prototype, OO = XP.open, OSD = XP.send;
      XP.open = function (m, u) { try { this.__u = "" + u; } catch (e) {} return OO.apply(this, arguments); };
      XP.send = function (b) {
        try {
          var s = this, u = s.__u || "";
          if (isCart(u) || isSug(u)) on(s, "load", function () { try { isSug(u) ? sug(u, s.responseText) : cart(u, b, s.responseText); } catch (e) {} });
        } catch (e) {}
        return OSD.apply(this, arguments);
      };
    } catch (e) {}

    /* The product page's Add to cart is a plain form POST, not AJAX, so neither hook
       above ever sees it — the funnel read 0 adds against real product views for that
       reason alone. Catch the submit, and flush before the page navigates away. */
    on(D, "submit", function (ev) {
      try {
        var f = ev && ev.target;
        if (!f || !f.getAttribute) return;
        if (("" + (f.getAttribute("action") || "")).indexOf("/cart/add") < 0) return;
        var id = f.querySelector('[name="id"]'), qy = f.querySelector('[name="quantity"]');
        var og = D.querySelector('meta[property="og:title"]');
        atc = 1;
        send("atc", {
          variant: id ? id.value : undefined,
          title: st(og ? og.content : D.title, 120),
          qty: parseInt((qy && qy.value) || 1, 10) || 1,
          via: "form"
        });
        flush(1);
      } catch (e) {}
    }, 1);

    /* ---- 5. checkout ---- */
    /* The bare `checkout` row used to store `{value: 0}` because the client sent
       nothing on it and the server defaulted the field. Ask Shopify's own cart
       endpoint for the totals — that call is free, same-origin, and returns the
       exact value about to be paid. Not fatal if it fails; the plain checkout
       row still lands. */
    if (location.pathname.indexOf("/checkouts/") > -1 || location.pathname.indexOf("/checkout") === 0) {
      send("checkout", { via: "page" });
      try {
        if (W.fetch) W.fetch("/cart.js", { credentials: "same-origin", cache: "no-store" })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (c) {
            if (!c) return;
            var val = typeof c.total_price === "number" ? c.total_price / 100 : undefined;
            var items = typeof c.item_count === "number" ? c.item_count : undefined;
            send("checkout", { via: "cartsync", value: val, items: items });
          })["catch"](function () {});
      } catch (e) {}
    }

    /* ---- 5 + 9: one click listener for checkout intent and rage ---- */
    on(D, "click", function (ev) {
      try {
        var el = ev.target, hops = 0, e2 = el;
        while (e2 && hops++ < 4) {
          var nm = e2.name || "", hr = e2.getAttribute ? (e2.getAttribute("href") || "") : "";
          var tag = e2.tagName || "", tx = (e2.textContent || "").replace(/\s+/g, " ");
          if (nm === "checkout" || hr.indexOf("/checkout") > -1 || (/check\s?out/i.test(tx.slice(0, 30)) && (tag === "BUTTON" || tag === "A"))) { send("checkout", { via: "click" }); flush(0); break; }
          e2 = e2.parentNode;
        }
        var t = now(), x = ev.clientX || 0, y = ev.clientY || 0, i, ok = 1;
        clicks.push({ x: x, y: y, t: t });
        while (clicks.length && t - clicks[0].t > 800) clicks.shift();
        if (clicks.length >= 3) {
          for (i = 0; i < clicks.length; i++) { var dx = clicks[i].x - x, dy = clicks[i].y - y; if (Math.sqrt(dx * dx + dy * dy) > 40) { ok = 0; break; } }
          if (ok) { send("rage", { n: clicks.length, tag: el && el.tagName ? el.tagName.toLowerCase() : undefined, txt: st(el && el.textContent, 40) }); clicks = []; }
        }
      } catch (e) {}
    }, 1);

    /* ---- 5b. click heatmap sample ----
       A separate listener from the checkout/rage one above, on purpose: this one
       runs on the bubble phase, so it never sees an event that a real handler has
       stopped, and it never fires for the click-through on interactive controls
       that stopPropagation. Capped per session so one restless visitor cannot
       fill the batch with 500 clicks, and normalised to page coords in [0, 1]
       so the read side can heatmap across viewports without a per-viewport divide.

       Selector is a short structural path (up to 5 hops, id or 2 classes each),
       enough to bucket clicks by control without dumping full CSS to the wire. */
    /* :nth-child was walking previousElementSibling until it fell off — on a
       200-tile grid that's thousands of hops per sampled click, synchronously
       in the handler. Cap at 30 siblings; past that, drop the index rather than
       burn cycles. Selector length capped at both ends: the RIGHT side of a long
       chain names the actual target, so slice from the front, not the back. */
    var CSS_SIBLING_SCAN = 30;
    function cssPath(el) {
      try {
        var parts = [], hops = 0;
        while (el && el.nodeType === 1 && hops++ < 5) {
          var seg = ("" + (el.tagName || "")).toLowerCase();
          if (el.id) { parts.unshift(seg + "#" + el.id); break; }
          var raw = el.className;
          var cls = (typeof raw === "string" ? raw : (raw && raw.baseVal) || "").trim();
          if (cls) seg += "." + cls.split(/\s+/).slice(0, 2).join(".");
          var p = el.parentNode;
          if (p && p.children && p.children.length > 1 && p.children.length <= CSS_SIBLING_SCAN) {
            var i = 1, s = el, scans = 0;
            while ((s = s.previousElementSibling) && scans++ < CSS_SIBLING_SCAN) i++;
            if (scans < CSS_SIBLING_SCAN) seg += ":nth-child(" + i + ")";
          }
          parts.unshift(seg);
          el = el.parentNode;
        }
        var prefix = parts.join(">");
        return prefix.length > 200 ? prefix.slice(0, 200) : prefix;
      } catch (e) { return ""; }
    }
    /* Nearest short label for the click target — never materialise the whole
       subtree text. A body-level click on a category page used to allocate
       megabytes of text just to slice it to 60 chars, then jank the handler. */
    function clickLabel(el) {
      try {
        if (!el || el === D.body || el === D.documentElement) return "";
        var s = el.getAttribute && (el.getAttribute("aria-label") || el.getAttribute("title") || el.getAttribute("alt"));
        if (s) return st(("" + s).replace(/\s+/g, " "), 60);
        var t = el.innerText;
        if (t) return st(t.replace(/\s+/g, " ").slice(0, 80), 60);
        return "";
      } catch (e) { return ""; }
    }
    on(D, "click", function (ev) {
      try {
        if (clickSampled >= CLICK_MAX) return;
        var nowT = now();
        if (nowT - lastClickAt < CLICK_COOLDOWN_MS) return;
        var el = ev.target; if (!el || !el.nodeType || el.nodeType !== 1) return;
        lastClickAt = nowT;
        var de = D.documentElement, vw = W.innerWidth || de.clientWidth || 1;
        var vh = W.innerHeight || de.clientHeight || 1;
        var pw = Math.max(vw, de.scrollWidth || 0);
        var ph = Math.max(vh, de.scrollHeight || 0);
        var cx = ev.clientX || 0, cy = ev.clientY || 0;
        var pxAbs = cx + (W.pageXOffset || de.scrollLeft || 0);
        var pyAbs = cy + (W.pageYOffset || de.scrollTop || 0);
        var ex = 0.5, ey = 0.5, targetEl = el;
        try {
          if (el.closest) {
            var tile = el.closest('a[href*="/products/"]');
            if (tile) targetEl = tile;
          }
          var r = targetEl.getBoundingClientRect ? targetEl.getBoundingClientRect() : null;
          if (r && r.width > 0 && r.height > 0) {
            ex = Math.min(1, Math.max(0, (cx - r.left) / r.width));
            ey = Math.min(1, Math.max(0, (cy - r.top)  / r.height));
          }
        } catch (e) {}
        var phandle = "";
        try {
          var a = el.closest ? el.closest('a[href*="/products/"]') : null;
          if (a && a.getAttribute) {
            var hh = a.getAttribute("href") || "";
            var m = hh.match(/\/products\/([^\/\?#]+)/);
            if (m) phandle = m[1].slice(0, 80);
          }
        } catch (e) {}
        clickSampled++;
        store(SS, "wbtc_click_n", "" + clickSampled);
        send("click", {
          sel: cssPath(el),
          tag: ("" + (el.tagName || "")).toLowerCase(),
          txt: clickLabel(el),
          x: cx, y: cy, vw: vw, vh: vh,
          px: Math.round((pxAbs / pw) * 1000) / 1000,
          py: Math.round((pyAbs / ph) * 1000) / 1000,
          ex: Math.round(ex * 1000) / 1000,
          ey: Math.round(ey * 1000) / 1000,
          ph: phandle
        });
      } catch (e) {}
    });

    /* ---- 6. errors ---- */
    /* An error with no message cannot be traced to anything, so it is never sent —
       it only ever added noise. Each distinct signature is reported once per page
       and no more than ERRMAX per page, because a single looping script used to
       emit hundreds of rows on its own. */
    var errSeen = {}, errN = 0, ERRMAX = 10;

    /* A rejection reason is whatever the code threw: an Error, a string, a Response,
       or an object with no useful toString. Only pull out something a human can read. */
    function why(r) {
      try {
        if (r == null) return "";
        if (typeof r === "string") return r;
        if (r.message) return "" + r.message;
        var s = "" + r;
        return s.indexOf("[object ") === 0 ? "" : s;
      } catch (e) { return ""; }
    }

    /* window.fetch on this storefront is wrapped several times over — Shopify's
       shop_events_listener wraps it, the web-pixels manager wraps it, this beacon
       wraps it, kwd-header wraps it for the cart refresh. So the TOP http frame of
       a rejected fetch is ALWAYS a wrapper and never the script that made the call:
       the board spent a day blaming shop_events_listener.js and wbtc-beacon.js for
       other people's network failures. Skip the wrappers, blame the first real caller. */
    var WRAP = /shop_events_listener|web-?pixels|\/cdn\/wpm\/|kwd-beacon\.js|kwd-header\.js|monitoring\/monitoring\.js/i;
    function frames(stk) {
      var out = [], re = /(https?:\/\/[^\s)'"]+?):(\d+):(\d+)/g, m;
      try { while (out.length < 8 && (m = re.exec("" + stk))) out.push(m); } catch (e) {}
      return out;
    }
    function blame(stk) {
      var f = frames(stk), i;
      for (i = 0; i < f.length; i++) if (!WRAP.test(f[i][1])) return f[i];
      return f[0] || null;
    }
    /* A compact trail of the top frames, so a misattribution never again has to be
       guessed at from a single filename: "vendor.min.js:1 < theme.js:2516". */
    function trail(stk) {
      var f = frames(stk), out = [], i;
      for (i = 0; i < f.length && out.length < 4; i++) out.push(f[i][1].split("?")[0].split("/").pop() + ":" + f[i][2]);
      return out.join(" < ");
    }

    /* A failed resource is NOT proof the file is missing, and believing it was cost a
       day. On 2026-08-16 the table held 313 image failures across 268 URLs; every one
       of those 268 answered 200 when fetched. They came from scrapers that ask for the
       HTML and then refuse the pictures — the browser fires the same error event for
       "the server said no" and "the client changed its mind", and there is no field on
       the event that tells them apart. Resource Timing does not settle it either: a
       request the client aborted leaves no entry, and neither does a DNS failure.

       So ask the network. On a resource error, fetch the same URL again and only report
       it if that comes back bad. An aborted image answers 200 the second time and is
       dropped; a genuinely dead file (the SMSBump form script, 403 on every page load)
       fails again and is kept. Cross-origin replies are opaque, so status is unreadable
       there — a reply at all means it exists, and only an outright network failure
       counts. Bounded by ERRMAX and deduped on URL, so a page cannot fetch in a loop. */
    var resSeen = {};
    function resErr(url, node) {
      var msg = "resource failed to load: " + node;
      try {
        if (resSeen[url]) return;
        resSeen[url] = 1;
        var report = function () { err(msg, url, 0, 0, null); };
        /* No fetch, or the page is on its way out and a verify would be cut off
           anyway: fall back to the old behaviour and report it unverified. */
        if (!W.fetch || errN >= ERRMAX) { report(); return; }
        var same = url.indexOf(location.origin + "/") === 0;
        W.fetch(url, {
          method: "GET", cache: "force-cache", credentials: "omit",
          mode: same ? "same-origin" : "no-cors"
        }).then(function (r) {
          /* Opaque cross-origin responses report status 0 — arriving is the only
             signal available, and it is enough to rule out a dead file. */
          if (same ? !r.ok : (r.type !== "opaque" && !r.ok)) report();
        })["catch"](function () {
          /* Only blame the file if the page is still here. A fetch that dies because
             the shopper navigated away tells us nothing about the file. */
          if (D.visibilityState !== "hidden") report();
        });
      } catch (e) { try { err(msg, url, 0, 0, null); } catch (x) {} }
    }

    function err(msg, src, line, col, stk) {
      try {
        msg = st(msg, 200); if (!msg) return;
        src = st(src, 200);
        var k = msg + "|" + src + "|" + (line || 0);
        if (errSeen[k]) return;
        errSeen[k] = 1;
        if (errN >= ERRMAX) return;
        errN++;
        send("err", {
          msg: msg, src: src || undefined, line: line || undefined, col: col || undefined,
          stack: st(trail(stk), 200) || undefined
        });
      } catch (e) {}
    }

    on(W, "error", function (ev) {
      try {
        if (!ev) return;
        /* A file that failed to load fires here too, because this listener is on the
           capture phase — but the event carries no `message`, so every one of them
           used to be thrown away by the empty-message guard below. A dead image, a
           404 on a stylesheet or an app script that never arrives is exactly the
           kind of breakage worth seeing, so name it from the element instead. */
        var tg = ev.target;
        if (tg && tg !== W && tg.nodeName && !ev.message) {
          var ru = tg.src || tg.href || "";
          if (ru) { resErr(ru, ("" + tg.nodeName).toLowerCase()); return; }
        }
        var e0 = ev.error, stk = e0 && e0.stack, b = blame(stk);
        /* A script a third-party app injects as an inline <script> reports the
           DOCUMENT as its filename, at line 1 — which names nothing at all, and is
           why every JSON SyntaxError looked like it lived in the theme. The stack
           still knows the truth, so prefer it whenever the filename is the page. */
        var f = ev.filename || "";
        var anon = !f || f === location.href || f.split("?")[0] === location.origin + location.pathname;
        err(ev.message || (e0 && e0.message),
            anon && b ? b[1] : f,
            anon && b ? parseInt(b[2], 10) : ev.lineno,
            anon && b ? parseInt(b[3], 10) : ev.colno,
            stk);
      } catch (e) {}
    }, 1);
    /* Anything the page's own security policy refuses to run or load. Silent in the
       console for the shopper, invisible everywhere else, and a common way for a
       newly added app to simply not work. */
    on(W, "securitypolicyviolation", function (ev) {
      try {
        if (!ev) return;
        err("blocked by content security policy: " + st(ev.violatedDirective, 60),
            st(ev.blockedURI, 200), ev.lineNumber || 0, ev.columnNumber || 0, null);
      } catch (e) {}
    });
    on(W, "unhandledrejection", function (ev) {
      try {
        var r = ev && ev.reason, stk = r && r.stack, b = blame(stk);
        err(why(r), b ? b[1] : "unhandledrejection", b ? parseInt(b[2], 10) : 0, b ? parseInt(b[3], 10) : 0, stk);
      } catch (e) {}
    });

    /* ---- 7. perf ---- */
    /* LCP, FCP and CLS all come from PerformanceObserver, all with buffered:true so
       an entry that fired before this script attached is still delivered. FCP has
       one entry and never changes; LCP keeps updating until the page stops loading;
       CLS accumulates from every layout shift the user did not just cause with an
       input (hadRecentInput === true is a user-caused shift and is excluded, per
       the Web Vitals spec). All three are re-sent on exit — the LCP and CLS
       snapshots at load-time nearly always undercount. */
    try {
      if (W.PerformanceObserver) new W.PerformanceObserver(function (l) {
        try { var es = l.getEntries(), e = es[es.length - 1]; if (e) lcp = Math.round(e.renderTime || e.startTime || 0); } catch (x) {}
      }).observe({ type: "largest-contentful-paint", buffered: true });
    } catch (e) {}
    try {
      if (W.PerformanceObserver) new W.PerformanceObserver(function (l) {
        try {
          var es = l.getEntries(), i;
          for (i = 0; i < es.length; i++) if (es[i].name === "first-contentful-paint") {
            fcp = Math.round(es[i].startTime); break;
          }
        } catch (x) {}
      }).observe({ type: "paint", buffered: true });
    } catch (e) {}
    try {
      if (W.PerformanceObserver) new W.PerformanceObserver(function (l) {
        try {
          var es = l.getEntries(), i;
          for (i = 0; i < es.length; i++) if (!es[i].hadRecentInput) cls += es[i].value || 0;
        } catch (x) {}
      }).observe({ type: "layout-shift", buffered: true });
    } catch (e) {}
    function perf() {
      if (perfDone) return; perfDone = 1;
      resolveID();
      try {
        var o = {}, P = W.performance, nv = P && P.getEntriesByType && P.getEntriesByType("navigation")[0];
        if (nv) { o.ttfb = Math.round(nv.responseStart); o.dcl = Math.round(nv.domContentLoadedEventEnd); o.load = Math.round(nv.loadEventEnd); o.nav = st(nv.type, 20); }
        else if (P && P.timing) { var t = P.timing, s = t.navigationStart; o.ttfb = t.responseStart - s; o.dcl = t.domContentLoadedEventEnd - s; o.load = t.loadEventEnd - s; }
        if (lcp) o.lcp = lcp;
        if (fcp) o.fcp = fcp;
        if (cls) o.cls = Math.round(cls * 1000) / 1000;
        // LCP/CLS are not final until the page stops loading, so the 2s snapshot almost always
        // reported 0. Re-send them once at exit, when the numbers are actually settled.
        perfSent = 1;
        send("perf", o);
      } catch (e) {}
    }
    if (D.readyState === "complete") setTimeout(perf, 2000); else on(W, "load", function () { setTimeout(perf, 2000); });

    /* ---- 10. exit ---- */
    function exit() {
      try {
        if (exited) return; exited = 1; measure();
        // Ship the settled numbers now: LCP, FCP and CLS are only final once the
        // page stops loading, which is why the 2s snapshot reported 0 for every
        // visitor.
        if (perfSent && (lcp || fcp || cls)) {
          var f = { final: 1 };
          if (lcp) f.lcp = lcp;
          if (fcp) f.fcp = fcp;
          if (cls) f.cls = Math.round(cls * 1000) / 1000;
          send("perf", f);
        }
        send("exit", { sec: sec(), sd: sd, atc: atc });
        flush(1);
      } catch (e) {}
    }
    on(W, "pagehide", exit);
    on(W, "beforeunload", exit);
    on(D, "visibilitychange", function () { try { if (D.visibilityState === "hidden") exit(); else exited = 0; } catch (e) {} });
  } catch (e) { /* never throw into the storefront */ }
})();
